import { createSelector } from 'reselect';
import getMatch from './getMatch';

const getModules = createSelector(
  [
    getMatch,
    () => {},
  ],
  // TODO: implement selector that resolves modules from entity metadata
  (match, data) => ({ ...match, ...data }),
);

export default getModules;
